module.exports = __webpack_public_path__ + "2022426:23e21cd641c426082ae7/img/carousel_04@1x.a2b2626.png";